import axios, { AxiosError } from 'axios';
import React, { useState } from 'react';
import config from '../../config';

const LiveDrawForm = (
    props: {
        handleLiveDrawForm: (token: string) => void,
        liveDrawIsLoading: boolean,
        paintId: string
    }
) => {
    const { handleLiveDrawForm, liveDrawIsLoading, paintId } = props;
    const [error, setError] = useState<null | string>(null)
    const [username, setUsername] = useState("");

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const token = localStorage.getItem('token');
        try {
            const result = await axios.post(`${config.api_server_uri}/paint/room/${paintId}/login`, { username }, { headers: { authorization: token || undefined } });
            handleLiveDrawForm(result.data.token);
        } catch (err) {
            if (err instanceof AxiosError) {
                if (err.response) {
                    setError(err.response.data.message);
                } else {
                    setError("unknown response")
                }
            } else {
                setError("unknown error")
            }
        }
    };
    return <>

        {
            liveDrawIsLoading ? <div className='w-full h-full dark:bg-gray-800 z-50 absolute flex justify-center items-center'>
                <svg className="w-10 h-10 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                </svg>
                <span className="sr-only">Loading...</span>
            </div> :
                <form onSubmit={handleSubmit} className='w-screen h-screen bg-white/90 dark:bg-gray-800 z-40 absolute flex items-center justify-center flex-col'>
                    {error ? <div className='w-full absolute top-3 flex justify-center items-center h-1/2 pointer-events-none'>
                        <div className="w-80 relative">
                            <div className="bg-red-100 border border-red-400 text-red-700 px-10 py-3 rounded mb-8 " role="alert">
                                <span className="block sm:inline">{error}</span>
                                <span className="absolute top-0 bottom-0 right-0 px-4 py-3 pointer-events-auto" onClick={() => setError(null)}>
                                    <svg className="fill-current h-6 w-6 text-red-500" role="button" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><title>Close</title><path d="M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" /></svg>
                                </span>
                            </div>
                        </div>
                    </div> :
                        null}
                    <div className="p-12">
                        <input
                            type="text"
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="enter your name"
                            required
                            onChange={(event) => setUsername(event.target.value)}
                            value={username}
                        />
                    </div>
                    <button
                        type="submit"
                        className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">
                        launch live draw
                    </button>
                </form>
        }

    </>;
};

export default LiveDrawForm;